angular.module('app.controllers.non-paginated-forms.historic', [])
    .controller("HistoricController", function ($scope, $window, $http, appConstants) {
        $scope.form_name = "Historic Information Request";
        $scope.aversion = appConstants.version;
        $scope.form_processed = "";
        $scope.caprequired = appConstants.captchaRequired; // localhost = false otherwise true
        $scope.allowedChars = /^[A-z0-9-'.,\!\+\(\)\/ ]+$/;
        $scope.commentsChars = /^[A-z0-9-'.,?\$\!\+\(\)\/\r\n ]+$/;
        $scope.addressChars = /^[A-z0-9-'.,\!\+\(\)\/\# ]+$/;
        $scope.onlyNumbers = /^([0-9]*)$/;
        $scope.validEmail = /^([\w-+\!\#\$\%\&]+(?:\.[\w-+\!\#\$\%\&]+)*)@((?:[A-z0-9-)]+\.)*\w[A-z0-9-]{0,66})\.([A-z0-9-]{2,8}(?:\.[A-z0-9-]{8})?)$/i;
        $scope.form_info = [
            "Use this form to request Statement of Rates not available on this website, other historical tariff information," +
            " (i.e., Rate Schedules, Rules, etc., or a copy of a pending advice letter or application) or to be added to the" +
            " advice letter service list in California."
        ];
        $scope.success_response = [
            "Thank You",
            "Your request for information has been received and is being processed. We will respond to your request within 3 business days."
        ];

        $window.setCapRequired = function (value) {
            $scope.caprequired = value;
            $scope.$digest();
            //   alert(value);
        };

        $scope.resetForm = function () {
            //alert($scope.resetForm);
            $scope.firstname = "";
            $scope.lastname = "";
            $scope.address = "";
            $scope.city = "";
            $scope.state = "";
            $scope.zipcode = "";
            $scope.phonenum = "";
            $scope.email = "";
            $scope.statementofrates = "";
            $scope.frommonth = "";
            $scope.fromyear = "";
            $scope.tomonth = "";
            $scope.toyear = "";
            $scope.serviceterritory = "";
            $scope.adviceletter = "";
            $scope.number = "";
            $scope.othertarriffinfo = "";
            $scope.informationrequesting = "";
            $scope.additionalinfo = "";
            $('html,body').scrollTop(0);
        };
        $scope.resetForm();

        $scope.submit = function () {
            if ($scope.form_processed === "") {
                $scope.form_processed = "Processing . . .";
                var firstName = $scope.firstname,
                    lastName = $scope.lastname,
                    address = $scope.address,
                    city = $scope.city,
                    state = $scope.state,
                    zip = $scope.zipcode,
                    phone = $scope.phonenum,
                    email = $scope.email,
                    historicStatementOfRates = $scope.statementofrates,
                    frommonth = $scope.frommonth,
                    fromyear = $scope.fromyear,
                    tomonth = $scope.tomonth,
                    toyear = $scope.toyear,
                    serviceTerritory = $scope.serviceterritory,
                    adviceLetter = $scope.adviceletter,
                    applicationNumber = $scope.number,
                    otherHistoricalTariffInfo = $scope.othertarriffinfo,
                    otherHistoricalTariffInfoText = $scope.informationrequesting,
                    additionalInfo = $scope.additionalinfo;

                $.ajax({
                    url: "/swgasws/resources/form/historicaltarriff/add",
                    type: "post",
                    dataType: 'json',
                    data: {
                        firstName: firstName,
                        lastName: lastName,
                        address: address.replace(/#/g, ":"),
                        city: city,
                        state: state,
                        zip: zip,
                        phone: phone,
                        email: email,
                        historicStatementOfRates: historicStatementOfRates,
                        frommonth: frommonth,
                        tomonth: tomonth,
                        fromyear: fromyear,
                        toyear: toyear,
                        serviceTerritory: serviceTerritory,
                        adviceLetter: adviceLetter,
                        applicationNumber: applicationNumber,
                        otherHistoricalTariffInfo: otherHistoricalTariffInfo,
                        otherHistoricalTariffInfoText: otherHistoricalTariffInfoText,
                        additionalInfo: additionalInfo,
                        gRecaptchaResponse: grecaptcha.getResponse()
                    },
                    success: function (data) {

                        switch (data.status) {
                            case 'success':
                                document.getElementById("responsemessage").innerHTML = "<p><span class='form-sub-good'>" + data.message + "</span>  We will respond to your request within 3 business days.</p>";
                                break;
                            case 'badrequest':
                                resp = data.toString().split("|");
                                document.getElementById("responsemessage").innerHTML = "<p><span class='form-sub-error'>" + data.message + " Please try again later.  The Webmaster has been notified of the submission problem(s). <br /> " + resp[1] + "</span></p>";
                                break;
                            case 'error':
                                document.getElementById("responsemessage").innerHTML = "<p><span class='form-sub-error'>" + data.message + " The Webmaster has been notified of the submission problem(s). <br /> </span></p>";
                                break;
                            default:  // all other errors
                                document.getElementById("responsemessage").innerHTML = "<p><span class='form-sub-error'>" + data.message + " The Webmaster has been notified about this problem.</span></p>";

                        }  // end switch

                        $scope.isDisabled = !0;
                        $scope.resetForm();
                        $scope.defaultForm.$setPristine();
                    },
                    error: function (response) {
                        document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>Your request has NOT been sent due to maintenance.  We apologize for the inconvenience at this time. Please try again later.</span></p>";
                        $scope.resetForm();
                        $scope.defaultForm.$setPristine();
                    }
                });
            }
        };

    });